module.exports = __webpack_public_path__ + "fonts/SourceHanSansSC-Bold-subset.c821dfbd.woff2";